var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCourses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_56_4326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28449 4.3995C3.25 5.82336 3.25 7.85446 3.25 11.9167V14.0833C3.25 18.1455 3.25 20.1767 4.28449 21.6005C4.61859 22.0604 5.02298 22.4648 5.48283 22.7989C6.90668 23.8333 8.93779 23.8333 13 23.8333C17.0622 23.8333 19.0933 23.8333 20.5172 22.7989C20.977 22.4648 21.3814 22.0604 21.7155 21.6005C22.75 20.1767 22.75 18.1455 22.75 14.0833V11.9167C22.75 7.85446 22.75 5.82336 21.7155 4.3995C21.3814 3.93966 20.977 3.53526 20.5172 3.20116C19.0933 2.16667 17.0622 2.16667 13 2.16667C8.93779 2.16667 6.90668 2.16667 5.48283 3.20116C5.02298 3.53526 4.61859 3.93966 4.28449 4.3995Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 7.85417C8.21728 7.85417 7.85352 8.21794 7.85352 8.66667C7.85352 9.1154 8.21728 9.47917 8.66602 9.47917H17.3327C17.7814 9.47917 18.1452 9.1154 18.1452 8.66667C18.1452 8.21794 17.7814 7.85417 17.3327 7.85417H8.66602ZM8.66602 12.1875C8.21728 12.1875 7.85352 12.5513 7.85352 13C7.85352 13.4487 8.21728 13.8125 8.66602 13.8125H17.3327C17.7814 13.8125 18.1452 13.4487 18.1452 13C18.1452 12.5513 17.7814 12.1875 17.3327 12.1875H8.66602ZM8.66602 16.5208C8.21728 16.5208 7.85352 16.8846 7.85352 17.3333C7.85352 17.7821 8.21728 18.1458 8.66602 18.1458H17.3327C17.7814 18.1458 18.1452 17.7821 18.1452 17.3333C18.1452 16.8846 17.7814 16.5208 17.3327 16.5208H8.66602Z",
    fill: "url(#paint0_linear_56_4326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_56_4326",
    x: -20.75,
    y: -21.8333,
    width: 67.5,
    height: 69.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_56_4326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_56_4326",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_4326",
    x1: 13.086,
    y1: 20.3384,
    x2: 27.2902,
    y2: 6.41485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCourses);
export default __webpack_public_path__ + "static/media/menu-courses.7863ec2b1ef185aa7ac8e83f05b0ca40.svg";
export { ForwardRef as ReactComponent };